export default {
    modalShowImageVariations: {
        imageAi: 'Imagen AI',
        regenerateImage: 'Generar nuevo contenido',
        description: 'Descripción',
        style: 'Estilo',
        saveToLibrary: 'Guardar en la biblioteca',
        continue: 'Continuar',
        cancel: 'Cancelar',
        select: 'Seleccionar',
        copy: 'Redacción',
        selectedImage: 'Imagen seleccionada',
        saved: 'Guardado',
        variations: 'Variaciones',
    },
};
